import { CLEAR_FAVORITES, GET_FAVORITES } from "../actions/types";

const favorites = (state = [], action) => {
    switch (action.type) {
        case GET_FAVORITES:
            return action.payload;
        case CLEAR_FAVORITES:
            return [];
        default:
            return state;
    }
};

export default favorites;
